import { createSlice } from "@reduxjs/toolkit";
import { db } from "../firebase.js";
import { ref, onValue, push, set, update, remove } from "firebase/database";

let unsubscribe = null;

// ─── Real-time listener ───────────────────────────────────────────────────────
export const subscribeSpecialOffers = () => (dispatch) => {
  if (!db) return;
  if (unsubscribe) unsubscribe();

  const offersRef = ref(db, "specialOffers");
  unsubscribe = onValue(
    offersRef,
    (snapshot) => {
      const data = snapshot.val() || {};
      const offers = Object.keys(data).map((k) => ({ id: k, ...data[k] }));
      dispatch(setOffers(offers.filter((o) => o.isActive)));
    },
    (error) => console.error("❌ SpecialOffers real-time error:", error.message)
  );
};

export const fetchSpecialOffers = () => subscribeSpecialOffers();

// ─── Write operations ─────────────────────────────────────────────────────────
export const createSpecialOffer = (offer) => async (dispatch) => {
  const offerRef = push(ref(db, "specialOffers"));
  const offerData = { ...offer, id: offerRef.key, createdAt: Date.now() };
  await set(offerRef, offerData);
};

export const updateSpecialOffer = ({ offerId, offer }) => async (dispatch) => {
  await update(ref(db, `specialOffers/${offerId}`), { ...offer, updatedAt: Date.now() });
};

export const deleteSpecialOffer = (offerId) => async (dispatch) => {
  await remove(ref(db, `specialOffers/${offerId}`));
};

// ─── Slice ────────────────────────────────────────────────────────────────────
const specialOffersSlice = createSlice({
  name: "specialOffers",
  initialState: { items: [], status: "idle", error: null },
  reducers: {
    setOffers(state, action) {
      state.items = action.payload;
      state.status = "succeeded";
    },
  },
});

export const { setOffers } = specialOffersSlice.actions;
export default specialOffersSlice.reducer;
